import type { AnyID } from '@types'
import { create } from 'zustand'

export type ModularToolbarScreenPos = {
  x: number
  y: number
  targetId: AnyID
}

/** Posición en vivo durante arrastre IKEA (fuera del store Immer → sin re-renders). */
export type LiveItemDrag = {
  itemId: AnyID
  x: number
  y: number
  z: number
}

type ModularUiStore = {
  itemDragActive: boolean
  draggingItemId: AnyID | null
  liveDrag: LiveItemDrag | null
  toolbarScreenPos: ModularToolbarScreenPos | null
  setItemDragActive: (active: boolean, itemId?: AnyID | null) => void
  setLiveDrag: (liveDrag: LiveItemDrag | null) => void
  setToolbarScreenPos: (pos: ModularToolbarScreenPos | null) => void
}

export const useModularUiStore = create<ModularUiStore>((set) => ({
  itemDragActive: false,
  draggingItemId: null,
  liveDrag: null,
  toolbarScreenPos: null,
  setItemDragActive: (itemDragActive, itemId = null) =>
    set((state) => ({
      itemDragActive,
      draggingItemId: itemDragActive ? itemId : null,
      liveDrag: itemDragActive ? state.liveDrag : null,
    })),
  setLiveDrag: (liveDrag) => set({ liveDrag }),
  setToolbarScreenPos: (toolbarScreenPos) => set({ toolbarScreenPos }),
}))
